<template>
    <project-step-container
            prev-to="js_deep_customer_empathy_2"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="first-form">
            <b-col cols="12" class=" text-center">
              <JAVideo title="Empathy Map"
                 :poster="{src: srcPoster, title:'Job Shadow Video'}"
                 :sources="videoSources"/>
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
               {{getMessage(3, 'empathy-map-sub')}}
            </b-col>

        </b-row>
         <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide :url="getMessage(3, isJACareerEntrepreApp ? 'empathy-map-link-new' : 'empathy-map-link')"
                                icon-name="icon-link" target="_blank"
                                :text="getMessage(3, 'empathy-map-link-text')"></LinkStyleGuide>
            </b-col>
        </b-row>

    </project-step-container>
</template>

<script>
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import JAVideo from "../../../core/Components/JAVideo"
    import Steps from "@/modules/JobShadow/Utils/steps";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "DeepCustomerEmpathy3",
        components: {ProjectStepContainer, JAVideo, LinkStyleGuide },
        data(){
            return{
                step:Steps.FORM_DEVELOP_EMPATHY
            }
        },
        computed: {
            srcPoster() {
                if (this.isJACareerEntrepreApp) {
                    return require('../Images/Customer_Empathy_new_logo.png');
                }

                return require('../Images/Customer_Empathy.jpg');
            },
            videoSources() {
                if (this.isJACareerEntrepreApp) {
                    return [
                        {
                            src: 'https://data.ja.org/s/Gj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 1440px)'
                        },
                        {
                            src: 'https://data.ja.org/s/GT0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 960px)'
                        },
                        {
                            src: 'https://data.ja.org/s/GD0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 720px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Fz0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 480px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Fj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 360px)'
                        },
                        {
                            src: 'https://data.ja.org/s/FT0AAA',
                            type: 'video/mp4',
                        },

                    ]
                }

                return [{
                    src: 'https://jad4dmedia-usso.streaming.media.azure.net/5b12e3f0-8b42-4b34-9078-b5317fe32232/Step_3_Customer_Empathy.ism/manifest',
                    type: 'application/vnd.ms-sstr+xml'
                }];
            }
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_deep_customer_empathy_4', params: {index}})
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import "~@/core/Styles/mixins.styl"

    .content-activity
        padding-top 15px
</style>
